export { LDScrollTo };
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

class LDScrollTo {
  duration = 1;
  offsetY = 0;

  constructor( duration, offsetY ) {
    
    if( duration !== undefined ){
      this.duration = duration;
    }

    if( offsetY !== undefined ){
      this.offsetY !== offsetY;
    }

    // If a link's href is within the current page, scroll to it instead
    document.querySelectorAll('a[href]').forEach(aLink => {
      
      aLink.addEventListener('click', clickEvent => {
        this.scrollToHash( this.getSamePageAnchor( aLink ), clickEvent );
      });

    });

    // Scroll to the element in the URL's hash on load
    this.scrollToHash(window.location.hash);
  }
  
  // Detect if a link's href goes to the current page
  getSamePageAnchor (link) {
    if (
      link.protocol !== window.location.protocol ||
      link.host !== window.location.host ||
      link.pathname !== window.location.pathname ||
      link.search !== window.location.search
    ) {
      return false;
    }

    return link.hash;
  }

  // Scroll to a given hash, preventing the event given if there is one
  scrollToHash( hashString, event ) {
    const targetAnchor = hashString ? document.querySelector(hashString) : false;

    if(targetAnchor) {
      if(event) event.preventDefault();
      
      let targetOffsetY = targetAnchor.getAttribute('data-offset-y');
      
      if( null === targetOffsetY ){
        targetOffsetY = this.offsetY;
      }
      
      gsap.to( window, {
        scrollTo: {
          y: targetAnchor,
          offsetY: targetOffsetY,
          autoKill: false,
          ease: 'power4.inOut'
        },
        duration: this.duration,
        // onComplete: function(){
        //  // NOTE: rewritting the location.hash overrides the offsetY above.
        //   window.location.hash = hashString;
        // }
      });
    }
  }

}